import React from 'react';
import { connect } from 'react-redux';
import styles from './GoalProgress.module.css';
import { PatientCareCenterNoteGoalProgressRow } from './Row';
import { PatientCareCenterNoteGoalProgressShortRow } from './ShortRow'

class PatientCareCenterNoteWpGoalProgress extends React.Component {

    render() {
        let index = 0;
        return (
            <div className={styles.wrapper}>
                <div className={styles.header}>
                    Goals
                </div>
                <div className={styles.body}>
                    Short Term Goals
                    {Object.keys(this.props.shortGoals)
                        .map(key => {
                            const result = this.props.shortGoals[key];
                            return (
                                <PatientCareCenterNoteGoalProgressShortRow key={result.SGNO} id={result.SGNO} isOdd={index++ % 2 === 0 ? false : true} />
                            )
                        })
                    }
                    {this.props.shortGoals.length === 0 &&
                        <br />
                    }
                    Long Term Goals
                    {Object.keys(this.props.goalsNonCustom)
                        .map(key => {
                            const result = this.props.goalsNonCustom[key];
                            return (
                                <PatientCareCenterNoteGoalProgressRow key={result.GONO} id={result.GONO} isOdd={index++ % 2 === 0 ? false : true} />
                            )
                        })
                    }
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let customGoalId = parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE)
    let customGoalIdWc = parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID_WC'].PRVALUE)

    let shortGoals = Object.keys(state.entities.notes.PTSHORTGOALS)
        .filter(key => {
            return ((noteType === 1 && state.entities.notes.PTSHORTGOALS[key]?.SGEVNO === pk) || (noteType !== 1 && state.entities.notes.PTSHORTGOALS[key].SGNTNO === pk)) &&
                (state.entities.notes.PTSHORTGOALS[key].SGACTIVE === true)
        })
        .sort((a, b) => {
            return state.entities.notes.PTSHORTGOALS[a].SGNO - state.entities.notes.PTSHORTGOALS[b].SGNO;
        })
        .map(key => state.entities.notes.PTSHORTGOALS[key]);


    let goalsNonCustom = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return ((noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)) &&
                (state.entities.notes.PTGOALS[key].GODELETED !== true)
                && (state.entities.notes.PTGOALS[key].GOMGNO !== customGoalId && state.entities.notes.PTGOALS[key].GOMGNO !== customGoalIdWc)

        })
        .sort((a, b) => {
            return state.entities.notes.PTGOALS[a].GONO - state.entities.notes.PTGOALS[b].GONO;
        })
        .map(key => state.entities.notes.PTGOALS[key]);

    return {
        goalsNonCustom,
        shortGoals
    };
}

const connectedPatientCareCenterNoteWpGoalProgress = connect(mapStateToProps)(PatientCareCenterNoteWpGoalProgress);
export { connectedPatientCareCenterNoteWpGoalProgress as PatientCareCenterNoteWpGoalProgress };

